import React, { useState } from "react";
import Secheader from "./common/Secondaryheader";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";

const Contact = () => {
  const scriptUrl =
    "https://script.google.com/macros/s/AKfycbypRgocfpZjxuxm76eQRQHm18J6mtWC3TC6iAkBEtdqEmCR4XB1O7oTDa2nIP2P9-Kl/exec";
  const [buttonColor, setButtonColor] = useState("#00e1ff");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    setLoading(true);
    setButtonColor("green");

    const formData = new FormData(form);

    try {
      const response = await fetch(scriptUrl, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Form submitted successfully!");
      } else {
        throw new Error("Failed to submit form.");
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Secheader
        sectitle="Get In Touch"
        secdesc="Thank you for your interest in Byteskull Technologies."
      />

      <section>
        <div className="container row py-5 m-auto">
          <div className="col-md-6 d-flex align-items-center justify-content-center order-1">
            <form
              className="col-lg-8 col-12 col-md-10 text-center"
              onSubmit={handleSubmit}
              name="google-sheet"
            >
              <p className="display-6 text-center mb-2">Reach us</p>
              <p>Our team is happy to answer your questions.</p>
              {/* Input fields with required attribute */}
              <div className="mb-3">
                <input
                  className="form-control"
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Your Name *"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  className="form-control"
                  id="email"
                  type="email"
                  name="email"
                  placeholder="Your Email *"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  className="form-control"
                  id="number"
                  type="tel"
                  name="number"
                  placeholder="Your Phone *"
                  required
                />
              </div>
              <div className="mb-3">
                <textarea
                  className="form-control form_textarea"
                  id="message"
                  name="message"
                  placeholder="Your message"
                  rows="3"
                ></textarea>
              </div>

              <input
                type="text"
                name="time"
                value={new Date().toString()} // Assuming you want to capture the current timestamp
                style={{ display: "none" }}
                readOnly
              />

              <button
                className="btn btn-lg btn_shadow col-12"
                type="submit"
                id="sub-btn"
                style={{ backgroundColor: buttonColor }}
                value={loading ? "Loading..." : "SEND MESSAGE"}
              >
                Send
              </button>
            </form>
          </div>

          <div className="col-md-6 d-flex align-items-center order-lg-1 order-md-2 flex-column py-5">
            <div className="row col-12">
              {/* <div className="col-md-8"> */}
              <span className="lead mb-3">Support</span>
              <p className="small">
                Feel free to reach out to us through any of the following
                channels.
                <br />
                <br />
                <span className="m-2 ml-0 hdrcolor">
                  <CallOutlinedIcon />
                </span>
                +91-9650937143, +91-7840091293
                <br />
                <br />
                <span className="m-2 ml-0 hdrcolor">
                  <EmailOutlinedIcon />
                </span>
                team.byteskull@gmail.com
                <br />
                <br />
                <span className="m-2 ml-0 hdrcolor">
                  <LocationOnOutlinedIcon />
                </span>
                New Delhi, India
              </p>

              {/* </div> */}
              {/* <div className="col-md-6">
							<span className="lead mb-3">Sales</span>
							<p className="small">Purchase lorem ipsum products.<br/><br/>
								<span className="m-2 ml-0 hdrcolor"><CallOutlinedIcon /></span>+4345335546<br/><br/>
								<span className="m-2 ml-0 hdrcolor"><EmailOutlinedIcon /></span>demo@example.com<br/><br/>
								<span className="m-2 ml-0 hdrcolor"><LocationOnOutlinedIcon /></span>New York, USA
							</p>
						</div> */}
            </div>

            {/* Google map */}
            <div className="row col-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.89796867163!2d77.04417115103875!3d28.527554409812666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x52c2b7494e204dce!2sNew%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1692513910130!5m2!1sen!2sin"
                width="530"
                height="270"
                style={{ border: 0, marginTop: "40px" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
